module.exports = __webpack_public_path__ + "static/img/env20.71df140.png";


//////////////////
// WEBPACK FOOTER
// ./src/module/technology/images/env20.png
// module id = 113
// module chunks = 4